import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../FrontEnd/Loading/LoadingSlice'
import {GetAllTeamList} from '../../pages/UserPages/accounts/Overview/OverviewSlice/TeamListSlice'
import {ENV} from '../../Utils/_helpers/EnvHelper'
import {GetCurrentData} from '../../Utils/_helpers/GetCurrentData'
import {toLower} from 'lodash'
import {defaultRegion} from '../../../_metronic/helpers'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  AssigneList: [],
}

////////////////////////////////////ASSIGNEE USER LIST////////////////////////////////////////////

export const getAllAssigneeUser: any = createAsyncThunk(
  '/getAllAssigneeUser',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/assignedUserListforSuperAdmin`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const UpdateAssigneTo: any = createAsyncThunk(
  '/UpdateAssigneTo',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/assignedUserbySuperAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getAllAssigneeUser({userId: data?.userId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const deallocateStaff: any = createAsyncThunk(
  '/deallocateStaff',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/unassignedUserbySuperAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getAllAssigneeUser({userId: data?.userId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const deallocateUser: any = createAsyncThunk(
  '/deallocateStaff',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/unassignedUserbySuperAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getAllAssigneeUser({userId: data?.staffId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const UpdateStatusForOwner: any = createAsyncThunk(
  '/updateStatusForOwner',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updateStatus`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllTeamList({userId: data?.userId}))
    {
      response.data.status === true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }
    return response.data
  }
)

export const ApprovedBussinessName: any = createAsyncThunk(
  '/UpdateAssigneTo',
  async (data: any, thunkApi) => {
    const request = {
      ...data,
    }

    const response: any = await axios.put(`${API_URL}admin/businessNameApprovel`, request, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    if (response?.data?.status) toast?.success(response?.data?.message)
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const AssignUser = createSlice({
  name: 'AssignUser',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin///////////////////////////////////////////////////////////////////
    [getAllAssigneeUser.fulfilled]: (state, {payload}) => {
      return {...state, AssigneList: payload.data}
    },
  },
})

export default AssignUser.reducer
